import {
  AspectRatio,
  Button,
  Heading,
  Link,
  Text,
  VStack,
} from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import { LinkIcon } from 'components/icons';
import React from 'react';
import { graphql, useFragment } from 'utils/graphClient';
import { BridgeViewer_node$key } from './__generated__/BridgeViewer_node.graphql';
import { isGoogleDriveUrl } from 'utils/isGoogleDriveUrl';
import { useFeatureFlag } from '../../../../../utils/sessionProvider';

const fileNodeFragment = graphql`
  fragment BridgeViewer_node on Node {
    id
    ... on FolderItem {
      id
      name
      content {
        __typename
        ... on BridgeInterface {
          url
        }
      }
    }
  }
`;

interface BridgeViewerProps {
  node: BridgeViewer_node$key;
}

export const BridgeViewer = ({ node }: BridgeViewerProps) => {
  const { name, content } = useFragment(fileNodeFragment, node);
  const isFeatureGoogleDriveIntegrationEnabled = useFeatureFlag(
    'FEATURE_GOOGLE_DRIVE_INTEGRATION_ITEM_VIEWER',
  );

  if (!content?.__typename?.includes('Bridge')) {
    return null;
  }

  if (
    isFeatureGoogleDriveIntegrationEnabled &&
    content.url &&
    isGoogleDriveUrl(content.url)
  ) {
    return <GoogleDriveViewer url={content.url} />;
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
      }}
    >
      <VStack
        width="100%"
        maxW={480}
        height={200}
        p={6}
        bg="blue.500"
        color="gray.50"
        borderRadius="md"
        display="flex"
        justifyContent="center"
        alignItems="center"
        spacing={3}
      >
        <Heading size="lg">{t`Bridge`}</Heading>

        <Text>{t`A bridge is a link to a resource outside of Govity.`}</Text>
        <Button
          color="gray.700"
          as={Link}
          toExternal={content.url}
          leftIcon={<LinkIcon />}
        >
          {' '}
          {name}
        </Button>
      </VStack>
    </div>
  );
};

const GoogleDriveViewer = ({ url }: { url: string }) => {
  return (
    <AspectRatio w="100%">
      <iframe src={url} />
    </AspectRatio>
  );
};
